/**
 * Custom hook for accessing Auth0 user information
 */

import { useAuth0 } from '@auth0/auth0-react'

export function useAuth() {
  const { user, isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0()

  const getToken = async (): Promise<string | null> => {
    try {
      if (!isAuthenticated) {
        return null
      }
      const token = await getAccessTokenSilently()
      return token
    } catch (error) {
      console.error('Failed to get access token:', error)
      return null
    }
  }

  return {
    user,
    isAuthenticated,
    isLoading,
    getToken,
    userId: user?.sub || null,
  }
}

